"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAccordion = void 0;
var colors_1 = require("../../generated/colors");
var global_1 = require("../../global");
exports.MuiAccordion = {
    defaultProps: {
        disableGutters: true,
    },
    styleOverrides: {
        root: {
            backgroundColor: colors_1.colors.White,
            boxShadow: "none",
            "&::before": {
                display: "none",
            },
            "&:last-of-type": {
                borderBottomLeftRadius: global_1.borderRadius.general,
                borderBottomRightRadius: global_1.borderRadius.general,
            },
            padding: global_1.spacing[3],
            borderRadius: global_1.borderRadius.general,
        },
    },
    variants: [
        {
            props: {
                variant: "secondary",
            },
            style: {
                backgroundColor: colors_1.colors.Mint25,
                "& .MuiAccordionSummary-expandIconWrapper": {
                    background: colors_1.colors.Primary,
                    borderRadius: global_1.borderRadius.fullyRounded,
                    color: colors_1.colors.White,
                    padding: global_1.spacing[1],
                },
            },
        },
    ],
};
//# sourceMappingURL=accordion.js.map